define([
    "dojo/_base/declare",
    "mw-form/MenuHeader",
    "../mixins/property/TypeMixin",
    "mw-form/mixins/mixinDependencyValidator"
], function (declare, MenuHeader, TypeMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([MenuHeader, TypeMixin]), {
        visualFamily: "default"
    });
});
